/**
 * #1777 — de laatste app-pagina vóór /support, zodat een ticket kan meesturen
 * waar de gebruiker tegenaan liep. Alleen in het geheugen van dit tabblad.
 */
let vorige: string | null = null;

export function onthoudPagina(pad: string): void {
  if (pad !== '/support') vorige = pad;
}

export function vorigePagina(): string | null {
  return vorige;
}
